/**
 * Catalog index — redirects to /sysadmin/catalog/functions.
 *
 * Previously redirected to /sysadmin/models, but the Models sub-tab deep-links
 * OUT to the legacy /sysadmin/models tree which does NOT render the Catalog
 * entity-tab bar — so the canonical Catalog landing stranded operators with no
 * clickable path to Functions/MCP/Tools/Workflows/Agents/Skills/Prompts.
 * Functions is a first-class route under catalog.tsx (renders the tab strip)
 * and hosts the AI function-builder helper, so it's the right default landing.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/catalog/functions' });
  },
});
